import React, { useState, useRef, useEffect } from 'react'
import ReactModal from 'react-modal'
// import '../../pages/Auth/node_modules/react-simple-keyboard/build/css/index.css'
import Keyboard from 'react-simple-keyboard'
import { BUTTON_KEYS } from './../../utils/translation-constants';
import { useTranslation } from 'react-i18next';

export default function KeyboardModal({ children, setText, clearText, closeModel }) {
  const keyboardRef = useRef(null)
  const [layout, setLayout] = useState('default')
  const {t}=useTranslation()

  const handleShift = () => {
    const newLayoutName = layout === 'default' ? 'shift' : 'default'
    setLayout(newLayoutName)
  }

  const onKeyPress = (button) => {
    console.log('Button pressed', button)
    if (button === '{shift}' || button === '{lock}') handleShift()
  }


  useEffect(() => {
    if (keyboardRef.current !== null) {
      keyboardRef.current.clearInput()
    }
  }, [clearText, keyboardRef])

  return (
    <ReactModal
      isOpen
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          border: 'none',
          borderRadius: '20px',
          marginRight: '-50%',
          boxShadow: '0 0 10px #AAAAAA',
          transform: 'translate(-50%, -50%)',
        },
      }}>
      <div className='d-flex flex-column text-center p-4'>
        {children}
        <Keyboard
          keyboardRef={(ref) => {
            keyboardRef.current = ref
          }}
          onChange={setText}
          onKeyPress={onKeyPress}
          layoutName={layout}
        />
        <button
          type='button'
          className='mt-2 btn btn-sm btn-link small new-design-warning-text-color font-weight-600'
          onClick={closeModel}>
          {t(BUTTON_KEYS.CLOSE)}
        </button>
      </div>
    </ReactModal>
  )
}
